module.exports = __webpack_public_path__ + "static/img/settings-white.7baf9ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/sidebar/settings-white.svg
// module id = 621
// module chunks = 2